import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import reactDom from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import {
  ErrorBoundary,
  setupGlobalErrorHandlers,
} from "./components/ErrorBoundary";
import "./index.css";
import { queryClient } from "./lib/query-client";

setupGlobalErrorHandlers();

async function enableMocking() {
  // VITE_ENABLE_MOCKING=false でMSWを無効化可能（Docker環境で実APIと通信する場合）
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCKING !== "false") {
    const { worker } = await import("./mocks/browser");
    return worker.start({
      onUnhandledRequest: "bypass",
    });
  }
}

enableMocking().then(() => {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }
  reactDom.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
});
